import { render, staticRenderFns } from "./SingleChoiceV1Properties.vue?vue&type=template&id=047b3043&"
import script from "./SingleChoiceV1Properties.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports